import { render } from "./TestView.vue?vue&type=template&id=8f807364&scoped=true"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"

import "./TestView.vue?vue&type=style&index=0&id=8f807364&scoped=true&lang=css"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f807364"]])

export default __exports__